import React, { useState, useEffect, useContext } from 'react';
import { Link } from "react-router-dom";
import AppContext from "../../appContext";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import LabCardGeneric from "../../shared/components/generic/lab-card/lab-card-generic";
import MESSAGES from "../../shared/constants/messages";
import { isLabIndependente } from "../../shared/constants/rolesCategories";
import CnpjUtils from "../../shared/utils/CnpjUtils";
import "../../shared/components/generic/lab-choose/lab-choose-generic.css";

const LAB_FILTER_KEY = 'LentePronta_c';

const LenteProntaLabChoose = ({ onSelectLab, userLabs }) => {
	const context = useContext(AppContext);
	const [allLabs, setAllLabs] = useState([]);
	const [labs, setLabs] = useState([]);
	const [loading, setLoading] = useState(false);
	const [onlyPreferidos, setOnlyPreferidos] = useState(false);
	const [hasPreferidos, setHasPreferidos] = useState(false);
	const [allPreferidos, setAllPreferidos] = useState(false);

	useEffect(() => {
		fetchLabs();
	}, []);

	useEffect(() => {
		filterLabs();
	}, [onlyPreferidos, allLabs]);

	const fetchLabs = async () => {
		setLoading(true);
		context.showLoading('Carregando laboratórios...');

		const requestOptions = {
			method: "POST",
			body: JSON.stringify({
				cnpjs: userLabs,
				papel: context.userSession.papel,
				conta: context.userSession.conta,
			}),
		};

		try {
			const response = await fetch(process.env.REACT_APP_LABS_API + "get_labs.php", requestOptions);
			const json = await response.json();

			if (json.items) {
				let hasPreferidosFlag = false;
				let onlyPreferidosFlag = false;

				const isLaboratorio = context.userSession?.papelCategoria === "LABORATORIO";
				const contaCnpj = CnpjUtils.cleanCnpj(context.userSession?.conta);

				const labsArray = json.items
					.filter(item => item[LAB_FILTER_KEY] === true)
					.filter(item => {
						if (!isLaboratorio) return true;
						const itemCnpj = CnpjUtils.cleanCnpj(item.CNPJ_c);
						return itemCnpj === contaCnpj;
					})
					.map(item => {
						if (!onlyPreferidosFlag && item.IsPreferido) {
							onlyPreferidosFlag = hasPreferidosFlag = true;
						}

						return {
							Id: item.Id,
							nome: item.Nome_c,
							telefone: item.Telefone_c,
							site: item.Site_c,
							email: item.Email_c,
							cnpj: item.CNPJ_c,
							logo: item.URL_Logo_c,
							promo: item.Promocao_c,
							corteRemoto: item.RemoteEdge_c,
							detailOrder: item.DetalhesDoPedido_c,
							IsCor_AR: item.IsCor_AR_c,
							IsGrowmocao: item.Growmocao_c,
							IsPreferido: item.IsPreferido || false,
							colorirNaOtica: item.ColorirNaOtica_c || false,
							CorteMontagemObrigatorio: item.CorteMontagemObrigatorio_c || false,
							IsPacto: item.Pacto_c || false,
							PossuiProgramaFidelidadeProprio_c: item.PossuiProgramaFidelidadeProprio_c || false,
							PactoNovaJornada: item.PactoNovaJornada_c || false,
						};
					});

				const allPreferidosFlag = hasPreferidosFlag &&
					labsArray.length === labsArray.filter(item => item.IsPreferido).length;

				setAllLabs(labsArray);
				setHasPreferidos(hasPreferidosFlag);
				setOnlyPreferidos(onlyPreferidosFlag);
				setAllPreferidos(allPreferidosFlag);
			}
		} catch (error) {
			console.error('Erro ao buscar laboratórios:', error);
		} finally {
			context.hideLoading();
			setLoading(false);
		}
	};

	const filterLabs = () => {
		let labsAux = [...allLabs].sort((x, y) =>
			x.IsPreferido === y.IsPreferido ? 0 : x.IsPreferido ? -1 : 1
		);

		if (onlyPreferidos) {
			labsAux = labsAux.filter(item => item.IsPreferido);
		}

		setLabs(labsAux);
	};

	const showAllLabs = () => setOnlyPreferidos(false);
	const hideAllLabs = () => setOnlyPreferidos(true);

	const papelCategoria = context.userSession?.papelCategoria;
	const papel = context.userSession?.papel;
	const isEssilor = papelCategoria === "ESSILOR";
	const isLaboratorio = papelCategoria === "LABORATORIO";
	const isLabInd = isLaboratorio && isLabIndependente(papel);
	const isLabLapa = isLaboratorio && !isLabInd;
	const showConfigLink = !isLabLapa && !isEssilor;

	return (
		<div className="row labChooseGrid" style={{ width: "70%", margin: "0 auto" }}>
			<div className="col-12 text-center">
				<h1 className="x-web-ordering__labs--title">{MESSAGES.LENTE_PRONTA_CHOOSE_TITLE}</h1>
				<p className="x-web-ordering__labs--paragraph text-center">
					{MESSAGES.LENTE_PRONTA_CHOOSE_SUBTITLE}
					{showConfigLink && (
						<>
							<br />
							Para configurar seus laboratórios preferenciais,{" "}
							<Link to="/empresa" className="x-web-ordering__intro--link x-web-ordering__intro--subtitle-bold">
								clique aqui.
							</Link>
						</>
					)}
				</p>
			</div>

			<div className="col-12 mx-auto">
				<div className="row text-center d-flex justify-content-center">
					{labs.map((lab, index) => (
						<div key={index} className="col-12 col-sm-6 col-md-4 col-lg-3">
							<LabCardGeneric
								lab={lab}
								onClick={() => onSelectLab(lab)}
							/>
						</div>
					))}

					{labs.length === 0 && !loading && (
						<div className="col-12 text-center">
							<p>{MESSAGES.LENTE_PRONTA_NO_LABS}</p>
						</div>
					)}
				</div>

				{hasPreferidos && !allPreferidos && (
					<div className="labChooseToggle">
						{onlyPreferidos ? (
							<a id="lab-toggle-all" className="labChooseToggle__btn" onClick={showAllLabs}>
								<ExpandMoreIcon className="labChooseToggle__icon" />
								<span>Ver todos os laboratórios</span>
							</a>
						) : (
							<a id="lab-toggle-preferred" className="labChooseToggle__btn" onClick={hideAllLabs}>
								<ExpandLessIcon className="labChooseToggle__icon" />
								<span>Ver apenas preferidos</span>
							</a>
						)}
					</div>
				)}
			</div>
		</div>
	);
};

export default LenteProntaLabChoose;
